<template>
    <div v-if="panel_required" class="designeroption" :data-designer-component-id="component_id">
        <h3> {{ title }} </h3>
        <div class="stylesoption">
            <div v-if="extra_text" class="mb-3">
                {{ extra_text }}
            </div>
            <div class="form-group">
                <input type="text" v-model="localTarget" id="glass_text" class="form-control" v-on:keyup="validChar()">
                <div class="row mt-1 txt-sm txt-light">
                    <div class="col" v-if="fabricator !== 29">
                        Characters allowed: 0-9
                    </div>
                    <div class="col align-right">
                        <span id="remain" class="small">{{ limit_input }}</span> characters remaining.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            title: {
                default(){
                    return 'Glass Text';
                }
            },
            component_id: {
                default(){
                    return 'glass_text';
                }
            },
            glassDesign: {
                required: true,
            },
            target: {
                default: ''
            },
            max_char: {
                default(){
                    return 3;
                }
            },
            extra_text: {
                default(){
                    return false;
                }
            },
            fabricator: {
                default(){
                    return undefined;
                }
            },
        },
        data(){
            return {
                options: {
                    has_text_option: false,
                },
                fetchData: window._.debounce(function() {
                    window.axios.post('/api/get-glass-text-options', {
                        glass_design: this.glassDesign,
                    })
                        .then((response) => {
                            this.options = response.data;
                        });
                }, 750)
            }
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            passed_filter(){
                return this.variable_ready(this.glassDesign);
            },
            url(){
                return '/api/options/' + this.fabricator + '/glass-text?glass_design=' + this.glassDesign;
            },
            cache_key(){
                return '_' + this.glassDesign;
            },
            panel_required(){
                return this.options.has_text_option != false;
            },
            limit_input(){
                if (this.localTarget.length >= this.max_char) {
                    $('#glass_text').val($('#glass_text').val().substring(0, this.max_char));
                }
                if (this.max_char - this.localTarget.length < 1) {
                    return 0;
                }
                return this.max_char - this.localTarget.length;
            },
        },
        watch: {
            'glassDesign': function (val, oldVal) {
                this.fetchData();
            },
        },
        activate(done){
            this.fetchData();
            done();
        },
        methods: {
            validChar() {
                if(this.fabricator === 29) {
                    this.localTarget = this.localTarget.replace(/[^a-zA-Z 0-9]+/g, '');
                } else {
                    this.localTarget = this.localTarget.replace(/\D/g, '');
                }
            }
        },
    }
</script>
